<template>
  <div>
    <clipboard-modal
      :show="modals.clipboard"
      @copy="copyEmailsToClipboard"
      @cancel="closeModalClipboard"
    >
      <div class="scrollable">{{ emailsToCopy }}</div>
    </clipboard-modal>
    <details-modal
      v-if="isPowerUserOrAdministrator"
      :show="modals.subcommittee"
      :current-operation="currentOperation"
      @cancel="closeModalSubcommittee"
      @create="subCommitteeButtonClicked"
    >
      <form id="subCommitteeForm">
        <div id="person-selection" class="row form-group2">
          <committee-select
            v-validate="'required'"
            v-show="modals.subcommittee"
            v-model="subcommitteeId"
            placeholder="Ajoutez une sous-commission"
            data-vv-scope="formSousCommissionDetails"
            name="Sous-commission"
            required
            @input="subcommitteeIdSelectedEvent"
          />
        </div>
        <span>{{
          errors.first(`formSousCommissionDetails.Sous-commission`)
        }}</span>
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <details-modal
      v-if="isPowerUserOrAdministrator"
      :show="modals.membership"
      :current-operation="currentOperation"
      @cancel="closeModalMembership"
      @create="createMembershipButtonClicked"
      @delete="deleteMembershipButtonClicked"
      @update="updateMembershipButtonClicked"
    >
      <form id="personForm">
        <div id="person-selection" class="row form-group2">
          <person-select
            v-validate="'required'"
            v-if="modals.membership && currentOperation === 'create'"
            v-model="selectedPersonId"
            placeholder="Ajoutez un membre"
            data-vv-scope="formMembershipDetails"
            name="Membre"
            required
          />
          <p v-else>{{ membership.name }}</p>
        </div>
        <span>{{ errors.first(`formMembershipDetails.Membre`) }}</span>
        <div class="row form-group2">
          <div class="col-md-6 p-0">
            <function-select
              v-show="selectedPersonId"
              v-model="membership.function"
              title="Fonction"
            />
          </div>
          <div class="col-md-6 p-0">
            <member-address-type-select
              v-validate="selectedPersonId ? 'required' : ''"
              v-show="selectedPersonId"
              :member-id="selectedPersonId"
              v-model="membership.addressType"
              title="* Type d'adresse"
              data-vv-scope="formMembershipDetails"
              name="addressType"
              required
            />
            <div class="select-element">
              {{ errors.first(`formMembershipDetails.addressType`) }}
            </div>
          </div>
        </div>
        <div class="row form-group2">
          <div class="col-md-6 p-0">
            <role-select
              v-show="selectedPersonId"
              v-model="membership.roleId"
              title="Role"
            />
          </div>
          <div class="col-md-6 p-0">
            <role-office-select
              v-show="selectedPersonId"
              v-model="membership.roleofId"
              title="Role Bureau"
            />
          </div>
        </div>
        <fg-input
          v-show="selectedPersonId"
          v-model="membership.notes"
          type="text"
          label="Notes"
        />
        <fg-input
          v-validate="modelValidations.sequenceNumber"
          v-show="selectedPersonId"
          v-model="membership.sequence"
          name="sequence"
          type="text"
          min="0"
          label="Séquence"
          data-vv-scope="formMembershipDetails"
        />
        <span v-if="errors.first('formMembershipDetails.sequence')">
          Le champ séquence ne peut contenir que des nombres positifs.
        </span>
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div
        class="col-md-12 top-button d-flex justify-content-between flex-wrap"
      >
        <div
          v-if="isPowerUserOrAdministrator"
          id="left-container"
          class="d-flex flex-wrap"
        >
          <button
            :class="editButtonClassObject"
            type="submit"
            class="top-button btn btn-fill btn-wd"
            aria-label="Editer"
            @click.prevent="editButtonClicked"
          >
            <a v-if="editingDisabled">Editer</a>
            <a v-else>Enregistrer</a>
          </button>
          <button
            v-show="!editingDisabled"
            type="warning"
            class="top-button btn btn-warning btn-fill btn-wd"
            aria-label="Annuler"
            @click.prevent="cancelButtonClicked"
          >
            Annuler
          </button>
          <button
            v-show="!editingDisabled && !newCommitteeCreation"
            type="danger"
            class="top-button btn btn-danger btn-fill btn-wd"
            aria-label="Effacer"
            @click.prevent="deleteButtonClicked"
          >
            Effacer
          </button>
          <p class="committee-error-message" v-if="committeeErrorMessage">
            {{ committeeErrorMessage }}
          </p>
        </div>
        <div id="right-container" class="d-flex justify-content-end">
          <button
            v-show="editingDisabled && !newCommitteeCreation"
            type="primary"
            class="top-button btn btn-primary btn-fill btn-wd"
            aria-label="Envoyer email aux professeurs"
            @click.prevent="exportEmailsToTxtButtonClicked"
          >
            E-mails Publics des membres
          </button>
          <div v-show="editingDisabled && !newCommitteeCreation">
            <drop-down>
              <p-button
                slot="title"
                slot-scope="{ isOpen }"
                :aria-expanded="isOpen"
                type="primary"
                class="dropdown-toggle"
                aria-label="Exporter"
              >
                Exporter
              </p-button>
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="exportToCsvIEButtonClicked(true)"
                >Windows (IE) CSV</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="exportToCsvOtherButtonClicked(true)"
                >Windows (Autres) CSV</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="exportToCsvOtherButtonClicked(false)"
                >Mac CSV</a
              >
            </drop-down>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Détails de la commission</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <form>
                  <div class="row">
                    <div class="col-md-12">
                      <fg-input
                        v-validate="'required'"
                        :disabled="editingDisabled"
                        v-model="committee.name"
                        data-vv-scope="formCommitteeDetails"
                        name="Nom"
                        required
                        type="text"
                        label="Nom"
                      />
                      <span>{{
                        errors.first('formCommitteeDetails.Nom')
                      }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <fg-input
                        :disabled="editingDisabled"
                        v-model="committee.acronym"
                        type="text"
                        label="Sigle"
                      />
                    </div>
                    <div class="col-md-6" v-if="isConnected">
                      <fg-input
                        v-validate="'required'"
                        :disabled="editingDisabled"
                        v-model="committee.managedBy"
                        data-vv-scope="formCommitteeDetails"
                        name="Responsable interne"
                        required
                        type="text"
                        label="Responsable interne"
                      />
                      <span>{{
                        errors.first('formCommitteeDetails.Responsable interne')
                      }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <fg-input
                        :disabled="editingDisabled"
                        v-model="committee.description"
                        type="text"
                        label="Description"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <fg-input
                        :disabled="editingDisabled"
                        v-model="committee.logoUrl"
                        type="text"
                        label="URL du logo"
                      />
                    </div>
                    <div class="col-md-6">
                      <fg-input
                        :disabled="editingDisabled"
                        v-model="committee.webSiteUrl"
                        type="text"
                        label="URL du site web"
                      />
                    </div>
                  </div>
                  <div v-if="canUserAccessPrivateData" class="row">
                    <div class="col-md-3">
                      <status-select
                        v-validate="'required'"
                        :disabled="editingDisabled"
                        v-model="committee.status"
                        data-vv-scope="formCommitteeDetails"
                        name="Statut"
                        required
                        title="Statut *"
                      />
                      <span>{{
                        errors.first('formCommitteeDetails.Statut')
                      }}</span>
                    </div>
                    <div class="col-md-3">
                      <default-select
                        :disabled="editingDisabled"
                        v-model="committee.isOfficial"
                        title="Annuaire public"
                      />
                    </div>
                  </div>
                  <div v-show="editingDisabled" class="row">
                    <div class="col-md-12">
                      <fg-input
                        :disabled="true"
                        v-model="committee.parentName"
                        type="text"
                        label="Commission Parent"
                      />
                    </div>
                  </div>
                  <div
                    v-if="isPowerUserOrAdministrator"
                    v-show="!editingDisabled"
                  >
                    <label>Commission Parent</label><br />
                    <committee-select
                      :disabled="editingDisabled"
                      v-model="committee.parentName"
                      class="d-flex flex-row align-items-center"
                      placeholder="Ajouter commission parent"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="!newCommitteeCreation" class="card">
          <div class="card-header">
            <h5 class="title">Membres et sous-commissions</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <tabs value="Description" tab-content-classes="text-center">
                  <tab-pane key="members" title="Membres">
                    <p>
                      Liste des membres
                      <button
                        v-if="isPowerUserOrAdministrator"
                        v-show="!editingDisabled"
                        id="btn-add"
                        type="button"
                        class="btn btn-icon btn-round btn-success"
                        aria-label="Ajouter un membre à la commission"
                        @click="createMembership"
                      >
                        <i class="fa fa-plus" />
                      </button>
                    </p>
                    <div class="row text-left">
                      <div class="col-md-12">
                        <div
                          class="card-body table-responsive table-full-width"
                        >
                          <el-table
                            :data="memberships"
                            :class="{ 'clickable-element': !editingDisabled }"
                            class="mydatalist"
                            @row-click="memberRowClicked"
                          >
                            <el-table-column label="Nom" min-width="12">
                              <div slot-scope="slotScope">
                                {{
                                  slotScope.row.person.lastName != null
                                    ? slotScope.row.person.lastName
                                    : '-'
                                }}
                                {{
                                  slotScope.row.person.firstName != null
                                    ? slotScope.row.person.firstName
                                    : '-'
                                }}
                              </div>
                            </el-table-column>
                            <el-table-column label="Fonction" min-width="12">
                              <div slot-scope="slotScope">
                                {{
                                  slotScope.row.function
                                    ? slotScope.row.function.name
                                    : '-'
                                }}
                              </div>
                            </el-table-column>
                            <el-table-column label="Note" min-width="11">
                              <div slot-scope="slotScope">
                                {{ slotScope.row.notes }}
                              </div>
                            </el-table-column>
                            <el-table-column label="Role" min-width="11">
                              <div slot-scope="slotScope">
                                {{
                                  slotScope.row.role
                                    ? slotScope.row.role.roleName
                                    : '-'
                                }}
                              </div>
                            </el-table-column>
                            <el-table-column label="Role Bureau" min-width="10">
                              <div slot-scope="slotScope">
                                {{
                                  slotScope.row.roleInCommitteeOffice
                                    ? slotScope.row.roleInCommitteeOffice
                                        .roleofName
                                    : '-'
                                }}
                              </div>
                            </el-table-column>
                            <el-table-column
                              v-if="isConnected"
                              label="Type d'Adresse"
                              min-width="12"
                            >
                              <div
                                v-if="slotScope.row.person.addresses[0]"
                                slot-scope="slotScope"
                              >
                                {{
                                  slotScope.row.person.addresses[0].addrTypeId
                                }}
                              </div>
                              <div v-else>-</div>
                            </el-table-column>
                            <el-table-column label="Adresse" min-width="25">
                              <div
                                v-if="slotScope.row.person.addresses[0]"
                                slot-scope="slotScope"
                              >
                                {{ slotScope.row.person.addresses[0].addrStreet
                                }}<br />
                                {{
                                  slotScope.row.person.addresses[0].addrPostalno
                                }}
                                {{ slotScope.row.person.addresses[0].addrCity
                                }}<br />
                                {{
                                  slotScope.row.person.addresses[0]
                                    .addrCountryName
                                }}
                              </div>
                              <div v-else>-</div>
                            </el-table-column>
                            <el-table-column
                              label="Communication"
                              min-width="30"
                            >
                              <div
                                v-if="slotScope.row.person.telecomInfos.length"
                                slot-scope="slotScope"
                              >
                                <div
                                  v-for="moc in slotScope.row.person
                                    .telecomInfos"
                                  :key="moc.info"
                                >
                                  {{
                                    removeAnnuaireAndDefautValuesFromStringIfNotConnected(
                                      moc.meanOfTelecom.mocName,
                                    )
                                  }}
                                  {{ moc.type }} : {{ moc.info }}
                                </div>
                              </div>
                              <div v-else>-</div>
                            </el-table-column>
                            <el-table-column label="Séq" min-width="7">
                              <div slot-scope="slotScope">
                                {{ slotScope.row.sequence }}
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </tab-pane>
                  <tab-pane key="subcommittees" title="Sous-commissions">
                    <p>
                      Liste des sous-commissions
                      <button
                        v-if="isPowerUserOrAdministrator"
                        v-show="!editingDisabled"
                        id="btn-add"
                        type="button"
                        class="btn btn-icon btn-round btn-success"
                        @click="addSubCommittee"
                        aria-label="Ajouter une sous-commission"
                      >
                        <i class="fa fa-plus" />
                      </button>
                    </p>
                    <div class="row text-left">
                      <div class="col-md-12">
                        <div
                          class="card-body table-responsive table-full-width"
                        >
                          <el-table
                            :data="subcommittees"
                            :class="{ 'clickable-element': !editingDisabled }"
                            class="mydatalist"
                          >
                            <el-table-column label="Nom" min-width="50">
                              <div slot-scope="slotScope">
                                {{ slotScope.row.name }}
                              </div>
                            </el-table-column>
                            <el-table-column label="Acronyme" min-width="20">
                              <div slot-scope="slotScope">
                                {{ slotScope.row.acronym }}
                              </div>
                            </el-table-column>
                            <el-table-column
                              v-if="canUserAccessPrivateData"
                              label="Statut"
                              min-width="20"
                            >
                              <div slot-scope="slotScope">
                                {{ slotScope.row.status }}
                              </div>
                            </el-table-column>
                            <el-table-column
                              v-if="
                                canUserAccessPrivateData && !editingDisabled
                              "
                              align="right"
                              label="Action"
                              min-width="20"
                            >
                              <div slot-scope="slotScope">
                                <button
                                  v-show="!editingDisabled"
                                  type="button"
                                  class="btn btn-icon btn-round btn-danger"
                                  aria-label="Enlever un membre de la sous-commission"
                                  @click="removeSubCommittee(slotScope.row)"
                                >
                                  <i class="fa fa-minus" />
                                </button>
                              </div>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </tab-pane>
                </tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Table, TableColumn } from 'element-ui';
import { Tabs, TabPane } from 'src/components/UIComponents';
import CommitteeSelect from 'src/components/ApplicationViews/UIComponents/CommitteeSelect.vue';
import DefaultSelect from 'src/components/ApplicationViews/UIComponents/DefaultSelect.vue';
import StatusSelect from 'src/components/ApplicationViews/UIComponents/StatusSelect.vue';
import PersonSelect from 'src/components/ApplicationViews/UIComponents/PersonSelect.vue';
import FunctionSelect from 'src/components/ApplicationViews/UIComponents/FunctionSelect.vue';
import RoleSelect from 'src/components/ApplicationViews/UIComponents/RoleSelect.vue';
import RoleOfficeSelect from 'src/components/ApplicationViews/UIComponents/RoleOfficeSelect.vue';
import MemberAddressTypeSelect from 'src/components/ApplicationViews/UIComponents/MemberAddressTypeSelect.vue';
import EventBus from 'src/event-bus';
import MixinUtils from '@/mixins/mixinUtils';

import {
  isConnected,
  canUserAccessPrivateData,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';

import swal from 'sweetalert2';
import { Validator } from 'vee-validate';

import fr from 'vee-validate/dist/locale/fr';
import DetailsModal from './Modals/DetailsModal.vue';
import ClipboardModal from './ClipboardModal.vue';

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    CommitteeSelect,
    DefaultSelect,
    StatusSelect,
    PersonSelect,
    FunctionSelect,
    RoleSelect,
    RoleOfficeSelect,
    MemberAddressTypeSelect,
    ClipboardModal,
    DetailsModal,
    Tabs,
    TabPane,
  },
  mixins: [MixinUtils],
  data() {
    return {
      modals: {
        membership: false,
        subcommittee: false,
        clipboard: false,
      },
      editingDisabled: true,
      newCommitteeCreation: false,
      committeeId: null,
      selectedPersonId: null,
      subcommitteeId: null,
      committee: {},
      memberships: [],
      membership: {
        function: undefined,
        notes: undefined,
        roleId: undefined,
        roleofId: undefined,
        sequence: undefined,
        addressType: undefined,
        name: undefined,
      },
      subcommittees: [],
      currentOperation: {},
      errorMessage: '',
      committeeErrorMessage: '',
      emailsToCopy: '',
      modelValidations: {
        sequenceNumber: {
          numeric: true,
          min_value: 0,
        },
      },
    };
  },
  computed: {
    isConnected,
    canUserAccessPrivateData,
    isPowerUserOrAdministrator,
    editButtonClassObject() {
      return {
        'btn-warning': this.editingDisabled,
        'btn-success': !this.editingDisabled,
      };
    },
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        this.newCommitteeCreation = newValue.params.newCommitteeCreation;
        if (this.newCommitteeCreation) {
          this.editingDisabled = false;
        } else {
          this.committeeId = newValue.params.id;
          this.fetch();
        }
      },
      deep: true,
    },
    selectedPersonId: {
      handler(newValue, oldValue) {
        // Reset the membership modal's data if the user selected another member in crate mode.
        if (this.currentOperation !== 'edit') {
          this.resetMembership();
        }
      },
    },
  },
  created() {
    this.newCommitteeCreation = this.$route.params.newCommitteeCreation;

    if (this.newCommitteeCreation) {
      this.editingDisabled = false;
    } else {
      this.committeeId = this.$route.params.id;
      this.fetch();
    }
    EventBus.$on('search', this.searchCommittee);
  },
  beforeDestroy() {
    EventBus.$off('search', this.searchCommittee);
  },
  mounted() {
    // Set the field validator to french
    Validator.localize('fr', fr);
  },
  beforeRouteUpdate(to, from, next) {
    this.committeeId = to.params.id;
    this.fetch();
    next();
  },
  methods: {
    searchCommittee(searchText) {
      this.$router.push({
        name: 'Committees',
        params: { searchText },
      });
    },
    showSwal(type) {
      if (type === 'warning-message-and-confirmation') {
        swal({
          title: 'Êtes-vous sûr de vouloir supprimer cette commission?',
          text: "Il ne sera pas possible d'annuler cette suppression!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Oui, effacer',
          cancelButtonText: 'Non, conserver',
          buttonsStyling: false,
        }).then(() => {
          this.deleteRecordCommittee();
        });
      } else if (type === 'membership-warning-message-and-confirmation') {
        swal({
          title:
            'Êtes-vous sûr de vouloir supprimer ce membre de la commission?',
          text: "Il ne sera pas possible d'annuler cette suppression!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Oui, effacer',
          cancelButtonText: 'Non, conserver',
          buttonsStyling: false,
        }).then(() => {
          this.deleteRecordMembership();
        });
      } else if (type === 'basic-email-copy-success') {
        swal({
          title: 'Succès',
          text:
            'Les adresses e-mail des membres ont été copiées dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success',
        });
      } else if (type === 'basic-email-copy-failure') {
        swal({
          title: 'Erreur',
          text: 'Impossible de copier dans le presse-papier',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'error',
        });
      }
    },
    editButtonClicked() {
      if (this.newCommitteeCreation) {
        // Validate that the required field are filled before creating record
        this.$validator.validateAll('formCommitteeDetails').then(result => {
          if (result) {
            this.createRecordCommittee();
          } else {
            this.committeeErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else if (!this.editingDisabled) {
        // Validate that the required field are filled before updating record
        this.$validator.validateAll('formCommitteeDetails').then(result => {
          if (result) {
            this.updateRecordCommittee();
            this.editingDisabled = !this.editingDisabled;
          } else {
            this.committeeErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else {
        this.editingDisabled = !this.editingDisabled;
      }
    },
    cancelButtonClicked() {
      if (this.newCommitteeCreation) {
        this.$router.push({ name: 'Committees' });
      } else {
        this.editingDisabled = true;
        this.fetch();
      }
    },
    deleteButtonClicked() {
      this.showSwal('warning-message-and-confirmation');
    },
    deleteMembershipButtonClicked() {
      this.showSwal('membership-warning-message-and-confirmation');
    },
    createRecordCommittee() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/`, {
          name: this.committee.name,
          parentId: this.committee.parentId,
          acronym: this.committee.acronym,
          status: this.committee.status,
          description: this.committee.description,
          logoUrl: this.committee.logoUrl,
          webSiteUrl: this.committee.webSiteUrl,
          managedBy: this.committee.managedBy,
          isOfficial: this.committee.isOfficial,
        })
        .then(response => {
          this.committeeId = response.data;
          this.committeeErrorMessage = '';
          this.newCommitteeCreation = !this.newCommitteeCreation;
          this.editingDisabled = !this.editingDisabled;

          this.$router.push({
            name: 'CommitteeDetails',
            params: { id: this.committeeId, newCommitteeCreation: false },
          });
        })
        .catch(error => {
          this.committeeErrorMessage =
            "Une erreur s'est produite : le nom de la commission doit être unique.";
        });
    },
    updateRecordCommittee() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/${this.committeeId}`,
          {
            name: this.committee.name,
            parentId: this.committee.parentId,
            acronym: this.committee.acronym,
            status: this.committee.status,
            description: this.committee.description,
            logoUrl: this.committee.logoUrl,
            webSiteUrl: this.committee.webSiteUrl,
            managedBy: this.committee.managedBy,
            isOfficial: this.committee.isOfficial,
          },
        )
        .then(response => {
          this.fetch();
          this.committeeErrorMessage = '';
        })
        .catch(error => {
          this.committeeErrorMessage =
            "Une erreur s'est produite: le nom de la commission doit être unique";
        });
    },
    deleteRecordCommittee() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/${this.committeeId}`,
        )
        .then(response => {
          this.committeeErrorMessage = '';
          this.$router.push({
            name: 'Committees',
          });
        })
        .catch(error => {
          this.committeeErrorMessage =
            'Une erreur est survenue lors de la suppression de la commission, veuillez réessayer ou contacter le support.';
        });
    },
    // MEMBERSHIPS
    memberRowClicked(row) {
      if (!this.editingDisabled && this.isPowerUserOrAdministrator) {
        this.currentOperation = 'edit';
        this.selectedPersonId = row.person.id;
        if (row.function) {
          this.membership.function = row.function.id;
        }
        this.membership.notes = row.notes;
        this.membership.sequence = row.sequence;
        this.membership.addressType = row.addressType;
        if (row.role) {
          this.membership.roleId = row.role.roleId;
        }
        if (row.roleInCommitteeOffice) {
          this.membership.roleofId = row.roleInCommitteeOffice.roleofId;
        }
        this.membership.name = `${row.person.lastName} ${row.person.firstName ||
          ''}`;
        this.modals.membership = true;
      }
    },
    closeModalMembership() {
      this.errorMessage = null;
      this.resetMembership();
      this.modals.membership = false;
    },
    createMembershipButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formMembershipDetails').then(result => {
        if (result) {
          this.createRecordMembership();
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs';
        }
      });
    },
    updateMembershipButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formMembershipDetails').then(result => {
        if (result) {
          this.updateRecordMembership();
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs';
        }
      });
    },
    createRecordMembership() {
      this.errorMessage = null;

      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/members/${this.committeeId}`,
          {
            mbrComtId: this.committeeId,
            mbrPersId: this.selectedPersonId,
            mbrFctId: this.membership.function,
            mbrNotes: this.membership.notes,
            mbrRoleId: this.membership.roleId,
            mbrRoleofId: this.membership.roleofId,
            mbrSequence: this.membership.sequence,
            mbrAddrtypeId: this.membership.addressType,
          },
        )
        .then(response => {
          this.closeModalMembership();
          this.fetch();
        })
        .catch(error => {
          if (error.response && error.response.status === 409) {
            this.errorMessage =
              'La personne sélectionnée est déjà membre de cette commission.';
          } else {
            this.errorMessage =
              'Une erreur est survenue, veuillez réessayer ou contacter le support.';
          }
        });
    },
    deleteRecordMembership() {
      this.errorMessage = null;

      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/members/${this.committeeId}/${this.selectedPersonId}`,
        )
        .then(response => {
          this.closeModalMembership();
          this.fetch();
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecordMembership() {
      this.errorMessage = null;

      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/members/${this.committeeId}/${this.selectedPersonId}`,
          {
            mbrComtId: this.committeeId,
            mbrPersId: this.selectedPersonId,
            mbrFctId: this.membership.function,
            mbrNotes: this.membership.notes,
            mbrRoleId: this.membership.roleId,
            mbrRoleofId: this.membership.roleofId,
            mbrSequence: this.membership.sequence,
            mbrAddrtypeId: this.membership.addressType,
          },
        )
        .then(response => {
          this.closeModalMembership();
          this.fetch();
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    resetMembership() {
      this.membership = {
        function: undefined,
        notes: undefined,
        roleId: undefined,
        roleofId: undefined,
        sequence: undefined,
        addressType: undefined,
        name: undefined,
      };
    },
    createMembership() {
      this.resetMembership();
      this.selectedPersonId = null;
      this.currentOperation = 'create';
      this.modals.membership = true;
    },
    // SUBCOMMITTES
    subcommitteeIdSelectedEvent(input, event) {
      this.subcommitteeId = input;
    },
    removeSubCommittee(subcommittee) {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/subcommittee/${this.committeeId}/${subcommittee.id}`,
        )
        .then(response => {
          this.committeeErrorMessage = '';
          this.fetch();
        })
        .catch(error => {
          this.committeeErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    addSubCommittee() {
      this.currentOperation = 'create';
      this.modals.subcommittee = true;
    },
    subCommitteeButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formSousCommissionDetails').then(result => {
        if (result) {
          this.createRecordSubcommittee();
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs';
        }
      });
    },
    createRecordSubcommittee() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/committee/subcommittee/${this.committeeId}/${this.subcommitteeId}`,
        )
        .then(response => {
          this.subcommitteeId = undefined;
          this.errorMessage = '';
          this.subcommitteeId = null;
          this.modals.subcommittee = false;
          this.fetch();
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    closeModalSubcommittee() {
      this.subcommitteeId = undefined;
      this.errorMessage = '';
      this.subcommitteeId = null;
      this.modals.subcommittee = false;
    },
    // Export
    doExportCsvRequest(windowsPlatform) {
      let url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/csv/`;

      if (this.canUserAccessPrivateData) {
        url += 'private';
      } else {
        url += 'public';
      }

      url += `/committees/${this.committeeId}?isWindowsPlatform=${windowsPlatform}`;

      return this.$http.get(url, {
        headers: {
          Accept: 'text/csv',
        },
      });
    },
    exportToCsvIEButtonClicked(windowsPlatform) {
      this.doExportCsvRequest(windowsPlatform)
        .then(response => {
          const BOM = '\uFEFF';
          const blobObject = new Blob([BOM + response.data]);

          window.navigator.msSaveBlob(
            blobObject,
            `liste_${this.committee.name ? this.committee.name : ''}.csv`,
          );
          // Or msSaveOrOpenBlob
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    exportToCsvOtherButtonClicked(windowsPlatform) {
      this.doExportCsvRequest(windowsPlatform)
        .then(response => {
          const BOM = '\uFEFF';
          const url = window.URL.createObjectURL(
            new Blob([BOM + response.data]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `commission_${this.committee.name ? this.committee.name : ''}.csv`,
          ); // or any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          this.committeeErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    closeModalClipboard() {
      this.committeeErrorMessage = '';
      this.emailsToCopy = '';
      this.modals.clipboard = false;
    },
    copyEmailsToClipboard() {
      const dummyTextToCopy = document.createElement('input');
      document.body.appendChild(dummyTextToCopy);
      dummyTextToCopy.setAttribute('value', this.emailsToCopy);
      dummyTextToCopy.select();
      const successful = document.execCommand('copy');

      if (successful) {
        this.showSwal('basic-email-copy-success');
      } else {
        this.showSwal('basic-email-copy-failure');
      }
      document.body.removeChild(dummyTextToCopy);
      this.closeModalClipboard();
    },
    exportEmailsToTxtButtonClicked() {
      const url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/txt/public/committees/${this.committeeId}/emailslist`;

      this.$http
        .get(url, {
          headers: {
            Accept: 'text/plain',
          },
        })
        .then(response => {
          this.emailsToCopy = response.data;
          this.modals.clipboard = true;
        })
        .catch(error => {
          this.listErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    // Fetch
    fetch() {
      const dto = this.canUserAccessPrivateData
        ? 'committeeDTO'
        : 'committeePublicDTO';
      const personDto = this.canUserAccessPrivateData
        ? 'PersonDTO'
        : 'PersonPublicDTO';

      let committeeUrl = `${process.env.VUE_APP_ANNUAIRE_API_URL}/committeeEntities/`;

      if (this.canUserAccessPrivateData) {
        committeeUrl += `${this.committeeId}?`;
      } else {
        committeeUrl += `search/findPublicCommitteeById?committeeId=${this.committeeId}&`;
      }

      committeeUrl += `projection=${dto}`;

      this.$http
        .get(committeeUrl)
        .then(response => {
          this.committee = response.data;
          if (this.committee.parentId === null) {
            this.committee.parentName = 'Aucun';
          }
        })
        .catch(() => {
          this.committeeErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });

      let membersUrl = `${process.env.VUE_APP_ANNUAIRE_API_URL}/memberEntities/search/findByMbrComtId`;

      if (!this.canUserAccessPrivateData) {
        membersUrl += 'Public';
      }

      membersUrl += `?projection=membershipBy${personDto}&committeeId=${this.committeeId}`;

      this.$http
        .get(membersUrl)
        .then(response => {
          this.memberships = response.data._embedded.memberEntities.sort(
            (a, b) => {
              if (a.sequence > b.sequence) {
                return 1;
              }

              if (a.sequence < b.sequence) {
                return -1;
              }

              if (a.person.lastName > b.person.lastName) {
                return 1;
              }

              if (a.person.lastName < b.person.lastName) {
                return -1;
              }

              return 0;
            },
          );
        })
        .catch(error => {
          this.committeeErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });

      let subCommitteesUrl = `${process.env.VUE_APP_ANNUAIRE_API_URL}/committeeEntities/search/find`;

      if (!this.canUserAccessPrivateData) {
        subCommitteesUrl += 'Public';
      }

      subCommitteesUrl += `SubCommittees?projection=${dto}&committeeId=${this.committeeId}`;

      this.$http
        .get(subCommitteesUrl)
        .then(response => {
          this.subcommittees = response.data._embedded.committeeEntities;
        })
        .catch(error => {
          this.committeeErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
  },
};
</script>

<style>
.mydatalist >>> tr {
  cursor: pointer;
}

.clickable-element {
  cursor: pointer;
}

.top-button {
  margin-top: -30px;
  margin-bottom: 0px;
}
.committee-error-message {
  margin-top: 10px;
  margin-left: 15px;
  padding-top: 10px;
  color: darkred;
}

.scrollable {
  overflow: auto;
  height: 300px;
}

#btn-add {
  position: absolute;
  right: 20px;
  top: 62px;
  margin: 0px;
}

#btn-export {
  position: absolute;
  right: 10px;
  top: 10px;
  margin: 0px;
}

#person-selection {
  font-size: 20px;
}

.validation-error {
  color: red;
  margin-bottom: 1em;
}

.select-element {
  padding-left: 30px;
}
</style>
